import type {BillingBeneficiary, OpenBillRow} from '../OpenBillsTable/types';

export interface DetailsDrawerProps {
	open: boolean;
	onClose: () => void;
	row: OpenBillRow | null;
	onPayBill?: () => void;
	hasAutoPayment?: boolean;
	isPayLoading?: boolean;
}

export interface CoparticipationTooltipCardProps {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
}

export interface BillingBeneficiaryItemProps {
	item: BillingBeneficiary;
	coparticipationLabel: string;
	onInfoIconClick: (el: HTMLElement) => void;
}

export interface ChargeDetailsAccordionContentProps {
	billingBeneficiaries: BillingBeneficiary[];
	totalValue: number;
	discountAmount: string | number;
	fineAmount: string | number;
	interestAmount: string | number;
	onInfoIconClick: (el: HTMLElement) => void;
}

export type DetailsDrawerInfoItemIconName =
	| 'calendar-range'
	| 'person-filled'
	| 'calendar-clock'
	| 'receipt-long-filled'
	| 'event-filled'
	| 'hapvida-logo';

export interface DetailsDrawerInfoItemProps {
	iconName: DetailsDrawerInfoItemIconName;
	primary: string;
	secondary: string;
}

export enum PlanAdjustmentLinkEnum {
	HAP = 'https://www2.hapvida.com.br/informacoes-regulatorias/reajuste-ans-2026-entenda-como-ficara-a-mensalidade-dos-planos-individuais',
	GNDI = 'https://www.gndi.com.br/informacoes-regulatorias/reajuste-ans-2026-entenda-como-ficara-a-mensalidade-dos-planos-individuais',
	CLINIPAM = 'https://www.gndisul.com.br/informacoes-regulatorias/reajuste-ans-2026-entenda-como-ficara-a-mensalidade-dos-planos-individuais',
	GNDI_MINAS = 'https://www.gndiminas.com.br/informacoes-regulatorias/reajuste-ans-2026-entenda-como-ficara-a-mensalidade-dos-planos-individuais',
	CCG = 'https://www.ccgsaude.com.br/informacoes-regulatorias/reajuste-ans-2026-entenda-como-ficara-a-mensalidade-dos-planos-individuais',
}
